var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24FormattextPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-format_text-point",
    "data-name": "icon-24-format text-point",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M2,16a2,2,0,1,1,2-2A2,2,0,0,1,2,16Zm15.5-1H6.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h11a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,15ZM2,10A2,2,0,1,1,4,8,2,2,0,0,1,2,10ZM17.5,9H6.5A.5.5,0,0,1,6,8.5v-1A.5.5,0,0,1,6.5,7h11a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,9ZM2,4A2,2,0,1,1,4,2,2,2,0,0,1,2,4ZM17.5,3H6.5A.5.5,0,0,1,6,2.5v-1A.5.5,0,0,1,6.5,1h11a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,3Z",
    transform: "translate(3 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24FormattextPoint);
export default __webpack_public_path__ + "static/media/icon-24-format text-point.c6f2724c60572e15c7a976528ee9464a.svg";
export { ForwardRef as ReactComponent };